<template>
  <div class="">
    <v-header :inputName='4'></v-header>
    <!-- <v-massage style="margin-bottom: 20px;"></v-massage> -->
    <div class="tuapainsd container" style="width: 1280px;min-height: 980px;padding-top: 70px;">
      <el-steps :active="step" finish-status="success" simple style="width: 1280px; margin-top: 20px;position: fixed;">
        <el-step title="信息确认" @click.native="changeStep(1)"></el-step>
        <el-step title="选择院校" @click.native="changeStep(2)"></el-step>
        <el-step title="选择专业" @click.native="changeStep(3)"></el-step>
        <el-step title="调整志愿" @click.native="changeStep(4)"></el-step>
      </el-steps>

      <div v-if="step == 1">
        <div style="margin-top: 100px;">
          <el-card class="box-card">
            <el-descriptions title="学生信息">
              <el-descriptions-item label="姓名"><b class="fontc">{{userInfo.userName}}</b></el-descriptions-item>
              <el-descriptions-item label="省份"><b
                  class="fontc">{{AREA_OBJ[userInfo.userProvinces]}}</b></el-descriptions-item>
              <el-descriptions-item label="手机号"><b class="fontc">{{userInfo.userPhone}}</b></el-descriptions-item>
              <el-descriptions-item label="学校"><b class="fontc">{{userInfo.userSchool}}</b></el-descriptions-item>
              <el-descriptions-item label="班级"><b class="fontc">{{userInfo.userEmail}}</b></el-descriptions-item>
            </el-descriptions>
          </el-card>

          <el-card class="box-card" style="margin-top: 10px;">
            <el-descriptions title="成绩信息">
              <el-descriptions-item label="科目">
                <el-tag size="small" style="margin-right: 15px;">{{SUBJECTTYPEOBJ[scoreInfo.scoreSubject]}}</el-tag>
                <span v-if="scoreInfo.scoreXuanke!=null&&scoreInfo.scoreXuanke!=''">
                  <b class="fontc">{{$utils.getUserXuanKe(scoreInfo.scoreXuanke)}}</b>
                </span>
              </el-descriptions-item>
              <el-descriptions-item label="成绩"><b class="fontc"
                  style="padding-right: 10px;">{{scoreInfo.score}}</b>分</el-descriptions-item>
              <el-descriptions-item label="位次"><b class="fontc">{{scoreInfo.scoreRank}}</b></el-descriptions-item>
            </el-descriptions>
          </el-card>
          <el-card class="box-card" style="margin-top: 10px;" v-if="userInfo.userRole == 3">
            <el-descriptions title="备注信息" :column="1">
              <el-descriptions-item label="学生资料" style="width:100%;"><b
                  class="fontc">{{userInfo.userImage}}</b></el-descriptions-item>
              <el-descriptions-item label="填报要求"><b class="fontc">{{userInfo.userQq}}</b></el-descriptions-item>
            </el-descriptions>
          </el-card>
        </div>

      </div>
      <div v-if="step == 2">
        <div style="margin-top: 80px;">
          <div class="search">
            <div class="serachkuang">
              <input placeholder="请输入您想查询的院校" v-model="collegequeryObj.collegeName" @keydown.enter="getCollegeData" />
              <div class="sousuo" @click="getCollegeData">
                <a href="#"><img src="../../src/assets/img/search.png" /></a>
              </div>
            </div>
          </div>
          <vCrumbs @search="searchAll"></vCrumbs>
          <div>
            <el-card class="box-card" style="margin-top: 20px;font-size: 18px; text-align: center;">
              根据条件查询获得院校：<b style="color: #e63233 ;">({{collegeTotal}})</b> 所，所有可选院校<b style="color: #e63233 ;">（2971）</b>所，您可根据需要更改筛选筛选条件，不筛选默认全部展示
            </el-card>
          </div>
        </div>
      </div>
      <div v-if="step == 3">
        <div>
          <div class="manpin" style="margin-top: 20px;">
            <div class="main centen container">
              <div class="main_r" style="padding-top: 60;">
                <div class="mainr_top">
                  <div class="search">
                    <div class="serachkuang">
                      <input placeholder="请输入您想查询的专业" v-model="majorName" @keydown.enter="search" />
                      <div class="sousuo" @click="search">
                        <a @click="search"><img src="../../src/assets/img/search.png" /></a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tiaobaodan">
                  <saixuantop1 :subject="userZhiYuanBatch.provincialBatch.indexOf('本')!=-1||userZhiYuanBatch.provincialBatch.indexOf('一段')!=-1?1:0" @select="selectType"></saixuantop1>
                  <div class="two">
                    <div class="schoolWZ">
                      <div class="SCLeft">
                        <span>可选专业</span>
                      </div>
                      <div class="SCbottom">
                        <el-breadcrumb separator="">
                          <el-breadcrumb-item><a @click="selectmajor(-2)" :class="allflag? 'active' :''">全选</a>
                          </el-breadcrumb-item>
                          <el-breadcrumb-item v-for="(item,index) in majorlist" :key="item.majorId"><a
                              @click="selectmajor(selectids.indexOf(item.majorId),item)"
                              :class=" selectids.indexOf(item.majorId)!=-1? 'active' :''">{{item.majorName}}</a>
                          </el-breadcrumb-item>
                        </el-breadcrumb>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <el-dialog title="已选专业" :show-close="false" :lock-scroll="false" :visible.sync="dialogVisible"
                width="50%">
                <div class="one">
                  <div class="xinxi" v-for="(item,index) in selectlist"><span>{{item.majorName}} </span>
                    <img src="../../static/img/cha.png" @click="del(index)">
                  </div>
                </div>
                <span slot="footer" class="dialog-footer">
                  <el-button type="danger" style="margin-right: 50px;" @click="clear()">重 置</el-button>
                  <el-button type="primary" @click="closelog">确 定</el-button>
                </span>
              </el-dialog>
              <vMassage2 :selectlist="selectlist" style="width: 1280px;" :flag="true" @openyixuan="openyixuan"
                @confirm="confirm" @clear="clear" @del="del"></vMassage2>
            </div>
          </div>
        </div>
      </div>
      <div v-if="step == 4||step == 5">
        <div style="margin-top: 80px;">
          <div class="generateAssess ">
            <div class="assess">
              <span :style="$utils.getrateStyle(zydRate)">{{zydRate}}</span>
              <h5 :style="$utils.getrateStyle(zydRate)">评估得分</h5>
            </div>
            <em></em>
            <div class="list">
              <div class="item">
                学生姓名：<span>{{userInfo.userName}}</span>
              </div>
              <div class="item">
                分数：<span>{{scoreInfo.score}}分</span>
              </div><br>
              <div class="item">
                选考科目：<span>{{SUBJECTTYPEOBJ[scoreInfo.scoreSubject]}}</span>
              </div>
              <div class="item">
                批次：<span>{{userZhiYuanBatch.provincialBatch}}</span>
              </div>

            </div>
            <div class="list" style="flex-direction: column;">
              <div class="item1">
                已选志愿：<span>{{list.length}}</span>
              </div>
              <div class="item1">
                已选院校：<span>{{collegenum}}</span>
              </div>
              <div class="item1">
                已选专业：<span>{{majornum}}</span>
              </div>

            </div>
          </div>
          <ul class="generateList" v-if="list.length!=0">
            <li v-for="(item,index) in list" :key="index" >
              <div class="xh" :style="$utils.getrateStyle(item.rate,1)">{{index+1}}</div>
              <div class="item">
                <div class="itemLeft flex-items" style="min-height: 148px;">
                  <div class="t1">
                    <span :style="$utils.getrateStyle(item.rate)">{{item.rate}}%</span>
                    <h5 :style="$utils.getrateStyle(item.rate)">概率</h5>
                  </div>
                  <div class="t2">
                    <h4 style="width: 520px;">
                      <router-link tag="a" target="_blank" :to="'/xyzy_jianjie?num=0&id='+item.collegeId">
                        {{item.collegeName}}
                      </router-link>
                      <span class="myspan" v-if="item.collegeInfo!=null&&item.collegeInfo!=''"
                        style="margin-left:10px;">{{item.collegeInfo}}</span>
                      <span class="myspan" v-if="tianbaoType != 0">
                        <span class="myspan" style="float: right;color: #F53824;">选科:{{item.xuankeStr}}</span>
                        <span class="myspan" style="float: right;color: #F53824;margin-right: 10px;"
                          v-if="tianbaoType == 2">分组:{{item.groupname}}</span>
                      </span>
                    </h4>
                    <div class="flex-items shipeishangxia" style="margin-top:5px;width: 520px;">
                      <div class="dm">
                        <p style="color: #F53824; width: 120px;"
                          v-if="item.collegeCode!=null&&item.collegeCode!=''&&$utils.getlocalStorage('showcode')">
                          院校代码：{{item.collegeCode}}
                        </p>
                        <p>{{item.collegeNature !=1?'民办':''}}
                          {{item.collegeLevel!=null&&item.collegeLevel!=""?"/"+item.collegeLevel.replace(/,/g,'/'):''}}
                        </p>
                      </div>
                    </div>
                    <icollege :item="item"></icollege>
                    <div class="flex-items shipeishangxia" style="width: 550px;" v-if="tianbaoType == 1">
                      <div class="dm">
                        <p style="color: #F53824; width: 110px;"
                          v-if="item.majorCode!=null&&item.majorCode!=''&&$utils.getlocalStorage('showcode')">
                          专业代码：{{item.majorCode}}</p>
                        <p style="margin-right:20px">
                          {{item.majorName}}
                          <span style="margin-left: 5px;color: #F53824;"  v-if="item.tuition!=null&&item.tuition!=''">
                            (学费：{{item.tuition}} 元)</span>
                        </p>

                      </div>
                      <p style="margin-right: 0;">{{item.planYear}}当年计划：<span
                          style="font-size:20px;color: #F53824;">{{item.planNum}}</span></p>
                    </div>
                    <imajor v-if="tianbaoType == 1" :item="item" ></imajor>
                    <div class="flex-items majorinfo" style="width: 520px;" v-if="tianbaoType == 1">
                      <p class="info">
                      {{item.majorInfo}}</p>
                    </div>
                  </div>
                  <div>
                    <yiscore  :score="item.score"  :year="scoreYear" style="width: 395px;margin-left: 30px;"></yiscore>
                  </div>
                </div>
                <div class="itemRigth">
                  <div class="flex-items" v-show="!dochuflag">
                    <a class="btn" @click="updatesort(index,true)">上调</a>
                    <a class="btn" @click="updatesort(index,false)">下调</a>
                    <!-- <a class="update">添加</a> -->
                    <a class="del" style="margin-left: 0;width: 50px; height: 25px;" @click="deleteZy(index)">删除</a>
                  </div>
                </div>
              </div>
              <div id="box" class="zhankaiNeirong" v-if="(!item.show&&tianbaoType!=1)||dochuflag">
                <div class="zymajor" v-for="(major,index1) in item.list">
                  <div class="text" style="width:120px;">
                    <div class="t1">
                      <span style="font-size: 18px;" :style="$utils.getrateStyle(major.rate)">{{major.rate}}%</span>
                      <h5>概率</h5>
                    </div>
                  </div>
                  <div style="flex-direction: column;justify-content: space-between;width: 70%;">
                    <div class="topBox">
                      <div class=" flex-items" style="min-width: 100%;justify-content: flex-start;">
                        <h4>{{major.majorName}}</h4>
                        <imajor :item="major" style="margin-left: 100px;"></imajor>
                      </div>
                    </div>
                    <div class=" flex-items" style="display: flex;justify-content: space-between;margin: 10px 0px;">
                      <div v-if="major.tuition!=null&&major.tuition!=''">学费：<b
                          style="color: #F53824;">{{major.tuition}}</b></div>
                      <div style="flex-direction: row;display: flex; justify-content: flex-end;">
                        <div class="dm" v-if="$utils.getlocalStorage('showcode')">专业代码：
                        <b style="color: #F53824;">{{getempty(major.majorCode)}}</b>
                        </div>

                      </div>
                      <div class="dm">{{major.planYear}}录取数：<b style="color: #F53824;">{{getempty(major.planNum)}}</b></div>
                    </div>

                    <p style="width:80%;color: #999999;" v-if="major.majorInfo!=null&&major.majorInfo!=''">
                      {{major.majorInfo}}
                    </p>
                  </div>
                  <div style="min-height: 148px;min-width: 430px;">
                    <yiscore  :score="major.score" :year="scoreYear" style="width: 395px;margin-left: 30px;"></yiscore>
                  </div>

                  <div class="flex-end" style="width:220px;" v-show="!dochuflag">
                    <div class="px" style="width: 38px;" v-if="item.list.length != 1">
                      <a @click="changMajorsort(index,index1,true)"><img src="./images/x.png"
                          style="transform: rotate(180deg);"></a>
                      <a @click="changMajorsort(index,index1,false)"><img src="./images/x.png"></a>
                    </div>

                    <span class="del" style="margin-top: 5px;" v-if="item.list.length != 1"
                      @click="delMajor(index,index1)">删除专业</span>
                  </div>
                </div>
              </div>
              <span v-if="tianbaoType != 1&&item.list!=null" class="zhankai"
                @click="openShutManager(index,item.id)">已选专业(<span>{{item.list.length}}</span>)个<img
                  src="./images/icon_xia.png"></span>
            </li>
          </ul>
          <loadData :loadding="loadding" v-if="list.length ==0&&!loadding" :noMore="false" :total="list.length" message="在您的筛选条件下无合适的备选志愿方案，请尝试修改院校或专业筛选条件后重新尝试"></loadData>




        </div>
      </div>
      <div class="ding" v-if="step!=3">
        <div class="container" style="width: 100%;">
          <div class="one" style="width: 1280px; padding-left: 10px;box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);">
            <div class="da">
            </div>
            <div class="showAll">
            </div>
            <div class="btnconfirm" @click="confirm" style="height: 50px;">{{getInfo()}}
              <b style="margin-left: 15px;" v-if="step == 4&&list.length!=0">(&nbsp;{{list.length}}&nbsp;)</b>
            </div>
          </div>
        </div>
      </div>
      <div class="mask" v-if="showcaozuo">
        <div class="maskA">
          <div class="maskAA">
            <p>使用须知</p>
            <!-- <img @click="showcaozuo = false" src="../../../src/assets/img/cha.png" /> -->
          </div>
          <div class="ANAN1">
            <figure>
              <figcaption>考生在取得自己高考成绩前模拟生成的志愿单不得作为志愿填报的参考，考生成绩公布后，考生按自己真实高考成绩生成的志愿单可作为高考志愿填报的参考。</figcaption>
            </figure>
            <figure>
              <figcaption>本系统提供的志愿单，仅作为考生志愿填报的参考，考生最终志愿的确定以自己最终决定为准。
                本系统提供志愿单中的院校及专业代码，仅供参考，最终请以考生所在省招生考试院公布的招生计划为准。</figcaption>
            </figure>
            <figure>
              <figcaption style="font-weight: 800;">特别提醒：本系统为志愿辅助生成平台，不是各省招生考试院的志愿填报平台，考生在本系统生成志愿后，必须要去考生所在省招生考试院规定的志愿填报网站填报高考志愿，切记！</figcaption>
            </figure>
            <figure class="wenz_r" style="flex-direction: row;justify-content: center;">
                <el-button type="danger" :disabled="loading" style="width: 180px;text-align: center;" @click="showcaozuo = false">
                  我已阅读此内容<b v-if="itime!=0">&nbsp;(  {{itime}} s )</b>
                </el-button>
            </figure>
          </div>
        </div>
      </div>

    </div>
    <item7></item7>
    <zuoxuanfu1></zuoxuanfu1>
    <toast :title="title" :message="message" @close="close" v-if="toastflag" :flag="toastflag" :fun="fun" @to="to"
      btn="que"></toast>
    <!-- 点击提交弹出 -->
  </div>
  </div>
</template>

<script>
  import vHeader from "../components/vHeader.vue";
  import item7 from "../components/item7.vue";
  import zuoxuanfu1 from '../components/zuoxuanfu1.vue'
  import vMassage from "../components/vMassage.vue";

  import vCrumbs from '../components/vCrumbs.vue'
import icollege from "../components/icollege.vue";
  import imajor from "../components/imajor.vue";
  import vMassage2 from "../components/vMassage2.vue";
  import jibenxinxi from '../components/jibenxinxi.vue'
  import saixuantop1 from '../components/saixuantop1.vue'
  import yiscore from './yiscore.vue'
  import toast from '../components/toast.vue'
import loadData from '../components/loadData.vue'

  export default {
    name: "",
    components: {
      vHeader,
      icollege,
      imajor,
      item7,
      zuoxuanfu1,
      vMassage,
      toast,

      vCrumbs,
      yiscore,
      jibenxinxi,
      vMassage2,
      saixuantop1,
      loadData
    },
    data() {
      return {
        step: 0,

        userInfo: this.$utils.getlocalStorage("userInfo"),
        AREA_OBJ: this.$utils.getlocalStorage("AREA_OBJ"),
        scoreInfo: this.$utils.getlocalStorage("scoreInfo"),
        SUBJECTTYPEOBJ: this.$utils.getlocalStorage("SUBJECTTYPEOBJ"),
        userZhiYuanBatch: this.$utils.getlocalStorage("userZhiYuanBatch"),
        tianbaoType: this.$utils.getlocalStorage("tianbaoType"),
        collegeName: "",
        collegeTotal: 0,
        collegequeryObj: {
          collegeName: '',
          collegeAreas: '',
          collegeLevel: '',
          collegeSubject: '',
          collegeSubjection: '',
          majorInfo: ''
        },

        loadding:true,
        dochuflag: false,


        majorName: '',
        typeId: '',
        allflag: false,
        list: [],
        majorlist: [],
        collegenum: 0,
        majornum: 0,
        zydRate: 0,
        scoreYear: 2024,

        title: "",
        message: "",
        toastflag: false,
        fun: '',

        selectlist: [],
        selectids: [],
        dialogVisible: false,

        showcaozuo: false,
        itime:8,
        loading:true



      }
    },
    created() {
      let map = this.$utils.getlocalStorage("zyyixuan")
      console.log(11)
      if (map) {
        this.selectlist = map.list
        this.selectids = map.ids
      }
      this.confirm()
    },
    methods: {
      close() {
        this.toastflag = false;
      },
      to() {
        this.$router.push('/grzx_wodezhiyuan')

      },
      changeStep(index) {
        this.step = index;
        if(index == 2){
          this.collegequeryObj = {
            collegeName: '',
            collegeAreas: '',
            collegeLevel: '',
            collegeSubject: '',
            collegeSubjection: '',
            majorInfo: ''
          }
        }
      },
      getInfo() {
        if (this.step == 1) {
          return "确认信息"
        } else if (this.step == 2) {
          return "确认选择"
        } else if (this.step == 4) {
          return "保存志愿"
        }
      },
      openyixuan() {
        if (this.selectlist.length != 0) {
          this.dialogVisible = true
        } else {
          this.$alert('请选择专业', '操作提示', {
            lockScroll: false
          });
        }
      },
      searchAll(obj) {
        this.collegequeryObj.collegeAreas = obj.collegeAreas
        this.collegequeryObj.collegeLevel = obj.collegeLevel
        this.collegequeryObj.collegeSubject = obj.collegeSubject
        this.collegequeryObj.collegeSubjection = obj.collegeSubjection
        this.collegequeryObj.majorInfo = obj.majorInfo
        this.getCollegeData();
      },

      getCollegeData() {
        let _this = this;
        this.$req.queryAllByLimit("collegeTable", {
          pageSize: 10,
          pageNum: 1,
          queryObj: _this.collegequeryObj
        }).then(function(response) {
          _this.collegeTotal = response.total;
        })
      },


      search() {
        this.typeId = ''
        this.allflag = false;
        this.getMajor()
      },
      selectType(typeId) {
        this.typeId = typeId
        this.majorName = '';
        this.allflag = false;
        this.getMajor()
      },
      confirm() {
        let _this= this
        this.step++;
        if (this.step == 2) {

          this.getCollegeData()
        }
        if (this.step == 4) {
          this.showcaozuo = true;
          let timer = setInterval(()=>{

            _this.itime--;
            console.log(_this.itime)
            if(_this.itime == 0){
              clearInterval(timer);
              _this.loading = false;
              // _this.showcaozuo = false;
            }
          },1000)
          this.getData()
        } else if (this.step == 5) {
          this.save();
        }
      },
      updatesort(index, flag) {
        let _this =this;
        if (this.list.length != 1) {
          if ((flag && index != 0) || (!flag && index != this.list.length - 1)) {
            let obj = this.list[index]
            let n = index + 1
            if (flag) {
              //上调
              n = index - 1
            }
            this.list[index] = this.list[n]
            this.list[n] = obj
            this.list[index].flag = false
            this.list[n].flag = false
            setTimeout(function(){
              _this.list[index].flag = true
              _this.list[n].flag = true
              _this.$forceUpdate()
            },0)
          }
        }
        this.$forceUpdate()
      },
      deleteZy(index) {
        this.list.splice(index, 1);
        this.getjishu()
      },
      getData() {
        let _this = this;
        _this.collegequeryObj.userScore = _this.scoreInfo.score;
        _this.collegequeryObj.batch = this.userZhiYuanBatch.provincialBatch;
        _this.collegequeryObj.scoretype = _this.scoreInfo.scoreSubject;
        _this.collegequeryObj.userArea = _this.scoreInfo.scoreArea;
        _this.collegequeryObj.majorids = this.selectids.join(",");
         _this.collegequeryObj.zybeiNum = 1;
        if (this.tianbaoType != 0) {
          let xuanke = _this.scoreInfo.scoreXuanke.split(",");
          _this.collegequeryObj.xk1 = xuanke[0];
          _this.collegequeryObj.xk2 = xuanke[1];
          _this.collegequeryObj.xk3 = xuanke[2];
          _this.collegequeryObj.jhflag = true
          _this.collegequeryObj.data_type = this.type;
          _this.collegequeryObj.tianbaoType = this.tianbaoType + "";
          if (this.userInfo.userRole == 3 || this.userInfo.userRole == 2) {
            _this.collegequeryObj.userId = this.userInfo.userId
          }

          this.$req.getYiJian({
            queryObj: _this.collegequeryObj,
          }).then(function(response) {
            _this.list = response.data
            _this.scoreYear = response.year
            _this.getjishu()
          })

        } else {
          _this.collegequeryObj.xiancha = (_this.scoreInfo.score - this.userZhiYuanBatch.provincialScore) + "";
          _this.collegequeryObj.use_score = true;
          this.$req.collegeYijianbao({
            queryObj: _this.collegequeryObj,
          }).then(function(response) {
            _this.list = response.data
            _this.getjishu()
          })
        }

      },
      getjishu() {
        let _this = this;
        let college = new Set();
        let major = new Set();
        this.list.forEach(function(item) {
          item.flag = true
          college.add(item.collegeId)
          if (_this.tianbaoType != 1) {
            item.list.forEach(function(majorinfo,index) {
              majorinfo.flag = true
              item.list[index].studyMoney = item.list[index].tuition
              major.add(majorinfo.majorId)
            })
          } else {
            item.studyMoney = item.tuition
            major.add(item.majorId)
          }
        })
        this.collegenum = college.size
        this.majornum = major.size
        if (this.list.length != 0) {
          this.zydRate = this.list[this.list.length - 1].rate;
        }
      },

      save() {
        let list = []
        let _this = this;
        let obj = {
          volunteerName: "未定义",
          volunteerRate: this.list[this.list.length - 1].rate,
          volunteerScore: this.scoreInfo.score,
          volunteerScoreRank: this.scoreInfo.scoreRank,
          spare: this.scoreInfo.scoreArea,
          spare1: this.scoreInfo.userId,
          spare2: this.userZhiYuanBatch.provincialYear,
          spare3: this.userInfo.userName,
          spare4: this.userZhiYuanBatch.provincialScore,
          volunteerMajor: this.majornum,
          volunteerCollege: this.collegenum,
          volunteerXuanke: this.getxuanke(this.scoreInfo.scoreXuanke),
          volunteerNum: this.list.length,
          volunteerSubject: this.scoreInfo.scoreSubject,
          volunteerBatch: this.$utils.getlocalStorage("userZhiYuanBatch").provincialBatch,
          volunteerYear: new Date().getFullYear(),
          dataStr: JSON.stringify(this.list),
          // spare5:this.$utils.getlocalStorage("user/ZhiYuanBatch").spare1

        }
        if (this.tianbaoType == 0) {
          obj.spare5 = this.$utils.getlocalStorage("userZhiYuanBatch").spare1
        }

        this.$req.insert("volunteerTable", obj).then(function(response) {
          if (response.status == "0") {
            _this.title = "温馨提示"
            _this.toastflag = true
            _this.fun = "close"
            _this.message = "你的志愿信息保存成功"
            _this.fun = "to"
          } else {
            _this.title = "温馨提示"
            _this.toastflag = true
            _this.fun = "close"
            _this.message = response.message
          }
        })
      },
      openShutManager(index, id) {
        this.list[index].show = !this.list[index].show
        //this.map[id].show = !this.map[id].show
      },
      getempty(str) {
        if (str == null || str == '') {
          return '--';
        }
        return str;
      },
      getxuanke() {
        let xuanke = null;
        let str = "";
        if (this.scoreInfo.scoreXuanke) {
          xuanke = this.scoreInfo.scoreXuanke.split(",");
          xuanke.forEach(function(item) {
            switch (item) {
              case 'wl':
                str += "物+";
                break;
              case 'ls':
                str += "历+";
                break;
              case 'hx':
                str += "化+";
                break;
              case 'sw':
                str += "生+";
                break;
              case 'dl':
                str += "地+";
                break;
              case 'zz':
                str += "政+";
                break;
              case 'xxjs':
                str += "信息+";
                break;
            }
          })
          return str.substring(0, str.length - 1)
        }
        return str;

      },






      clear() {
        this.allflag = false;
        this.selectlist = [];
        this.selectids = [];
        this.$utils.removelocalStorage("zyyixuan");
      },

      getMajor() {
        let _this = this;
        let obj = {}
        if (_this.typeId != null && _this.typeId != '') {
          obj.majorTypeId = _this.typeId
        }
        if (_this.majorName != null && _this.majorName != '') {
          obj.majorName = _this.majorName
        }
        this.$req.queryAllByLimit('majorTable', {
          pageNum: 1,
          pageSize: 0,
          queryObj: obj
        }).then(function(response) {
          _this.majorlist = response.data
          _this.getAllflag()
        })
      },
      changMajorsort(index, index1, flag) {
        let _this = this;
        if ((flag && index1 != 0) || (!flag && index1 != this.list[index].length - 1)) {
          let obj = this.list[index].list[index1]
          let n = 0
          if (flag) {
            //上调
            n = index1 - 1
          } else {
            n = index1 + 1
          }
          this.list[index].list[index1] = this.list[index].list[n]
          this.list[index].list[n] = obj
          this.list[index].list[index1].flag = false;
          this.list[index].list[n].flag = false;
          setTimeout(function(){
            _this.list[index].list[index1].flag = true;
            _this.list[index].list[n].flag = true;
            _this.$forceUpdate()
          },0)
          this.$forceUpdate()
        }
      },
      selectmajor(index, item) {
        if (index == -2) {
          if (!this.allflag) {
            for (let a in this.majorlist) {
              if (this.selectids.indexOf(this.majorlist[a].majorId) == -1) {
                this.selectids.push(this.majorlist[a].majorId)
                this.selectlist.push(this.majorlist[a]);
              }
            }
            this.allflag = true
          } else {
            for (let a in this.majorlist) {
              let i = this.selectids.indexOf(this.majorlist[a].majorId)
              if (i != -1) {
                this.selectids.splice(i, 1);
                this.selectlist.splice(i, 1);
              }
            }
            this.allflag = false
          }
        } else {
          if (index != -1) {
            this.selectids.splice(index, 1);
            this.selectlist.splice(index, 1);
          } else {
            this.selectids.push(item.majorId)
            this.selectlist.push(item);
          }
          this.getAllflag();
        }

      },
      delMajor(index, index1) {
        this.list[index].list.splice(index1, 1);
        if (this.list[index].list.length == 0) {
          this.list.splice(index, 1);
        }
        this.getjishu();
        this.$forceUpdate()
      },
      del(index) {
        this.selectids.splice(index, 1);
        this.selectlist.splice(index, 1);

      },
      closelog() {
        this.dialogVisible = false
        this.getMajor()
      },
      getAllflag() {
        let n = 0
        for (let a in this.majorlist) {
          if (this.selectids.indexOf(this.majorlist[a].majorId) != -1) {
            n++
          }
        }
        if (n == this.majorlist.length) {
          this.allflag = true
        } else {
          this.allflag = false
        }
      },

    }
  }
</script>

<style scoped>
  .container {}

  .fontc {
    color: #e63233;
  }


  .serachkuang .sousuo img {
    padding: 5px 15px 5px 15px;
    background: red;
    border-radius: 0 6px 6px 0;
  }

  .serachkuang input {
    border: none;
    width: 500px;
    height: 40px;
    background: #fff;
    font-size: 16px;
    line-height: 40px;
    opacity: 1;
    border: 1px solid #c0c4cc;
    border-radius: 6px 0px 0px 6px;
    padding-left: 15px;
    padding: 15px;
  }

  .serachkuang ::-webkit-input-placeholder {
    color: #999999;
    font-size: 16px;
  }

  .serachkuang {
    display: flex;
    height: 100%;
    text-align: center;
    align-items: center;
    justify-content: center;
  }

  .search {
    /* width: 500px; */
    /* margin-left: 200px; */
    height: 40px;
    margin-top: 0px;
    justify-content: center;
    align-items: center;
  }

  .two {
    margin-top: 10px;
    justify-content: space-around;
    width: 100%;
    background: rgba(255, 255, 255, 0.39);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
    opacity: 1;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    padding: 20px;
    min-height: 50px;
  }

  .two span {
    line-height: 50px;
    margin-right: 8px;
  }

  .schoolWZ {
    width: 100%;
    height: auto;
    display: flex;
  }


  .schoolWZ .SCLeft {
    width: 115px;
  }

  .schoolWZ .SCLeft span {
    color: #000;
  }

  .schoolWZ .SCmain {
    width: 64px;
    height: 60px;
    margin-right: 15px;
    margin-top: 10px;

  }

  .schoolWZ .SCmain a {
    display: block;
    text-align: center;
    line-height: 32px;
    font-weight: 600;
    height: 32px;
    color: #333333;
    opacity: 1;
    cursor: pointer;
    font-size: 14px;
    margin: 0 10px;
  }

  .active {
    background: #e63233;
    color: #fff !important;
    border-radius: 16px;
    padding: 6px 11px;
    box-sizing: border-box;
  }

  .schoolWZ .SCbottom {
    width: 100%;
    text-align: left;
    /* padding-bottom: 10px; */
    /* border-bottom: 1px #eee9e9 solid; */
  }

  .schoolWZ .SCbottom a {
    text-decoration: none;
    cursor: pointer;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 600;
    padding: 6px 11px;
    line-height: 20px;
    color: #333333;
    opacity: 1;
  }

  .one {
    justify-content: left;
    align-items: flex-start;
    width: 100%;
    height: auto;
    background: #FFFFFF;
    display: flex;
    padding-left: 20px;
    flex-wrap: wrap;
  }

  .xinxi {
    padding: 0 5px 0 5px;
    width: auto;
    height: 30px;
    background: rgba(255, 255, 255, 0.39);
    border: 1px solid #29A7E1;
    opacity: 1;
    margin-right: 15px;
    margin-bottom: 15px;
    border-radius: 5px;
    line-height: 30px;

  }

  .xinxi span {
    text-align: center;
    font-size: 14px;
    text-decoration: none;
    color: #29A7E1;
    font-family: PingFang SC;
    font-weight: 500;

  }

  .xinxi img {
    width: 10px;
    height: 10px;
    margin-top: -3px;
    margin-left: 5px;
  }



  .ding {
    position: fixed;
    bottom: 0;
    width: 100%;
  }

  .btn {
    width: 50px !important;
    height: 25px important;
    font-size: 16px;
    line-height: 15px;
    border-radius: 8px;
    margin-left: 0px !important;
    margin-right: 10px;

  }

  .btnconfirm {
    /* background-color: #e63233;
      color: #FFFFFF; */
    width: 200px;
    height: 100%;
    background-color: #f66464;
    color: #FFFFFF;
    font-size: 20px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .showAll {
    width: 200px;
    text-align: right;
    padding-right: 10px;
    font-size: 18px;
    color: #29A7E1;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .showAll .xia {
    width: 12px;
    height: 15px;
    margin-left: 10px;
    background-repeat: no-repeat;
    transform: rotate(180deg);
    background-size: 100% 100%;
    background-image: url(../views/images/icon_xia.png);
  }

  .btnclear {
    color: #666;
    border: 1px solid #666;
  }

  .da {
    display: flex;
    justify-content: row;
    flex-wrap: nowrap;
    align-items: center;
    flex-shrink: 0;
    width: 850px;
    height: 100%;
    overflow: hidden;
    margin-left: 20px;
  }


  /* 遮罩层  ↓ */
  .mask {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 120;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .maskA {
    width: 700px;
    height: 380px;
    background: rgb(255, 255, 255);
    border-radius: 20px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
  }

  .maskAA {
    width: 700px;
    height: 64px;
    background-image: url("../assets/img/zzctop.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 28px;
    padding-left: 28px;
    margin-bottom: 10px;
    box-sizing: border-box;
  }

  .maskAA img {
    width: 28px;
    height: 28px;
    cursor: pointer;
  }

  .ANAN1 {
    width: 100%;
    padding-bottom: 10px;
    padding-left: 50px;
    padding-right: 50px;
    padding-top: 20px;
    /* height: calc(100% - 170px); */

    height: 380px;
  }

  .maskAA p {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }

  .ANAN1 figure {
    display: flex;
    margin-bottom: 18px;

  }

  /* .ANAN1 figure span {
    margin-right: 15px;
    background-color: #F44F25;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 18px;
    border-radius: 15px;
    width: 25px;
    height: 25px;
  } */

  .ANAN1 figure figcaption {
    text-indent: 1cm;
    font-size: 16px;
    /* line-height: 30px; */
    color: #F53824;
    font-family: PingFang SC;
    font-weight: 500;
  }

</style>



// WEBPACK FOOTER //
// src/views/yijiantianbao.vue